import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { TrendingUp } from '@mui/icons-material';
import { siteConfig } from '../config/siteConfig';

const PerformanceStats = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <Typography variant="h3" sx={{ fontWeight: 'bold', mb: 2, color: siteConfig.colors.secondary }}>
            Bis zu <span style={{ color: siteConfig.colors.primary }}>+45%</span> mehr Leistung
          </Typography>
          <Typography variant="h6" sx={{ color: siteConfig.colors.text }}>
            Leistungssteigerung mit Qualität und Garantie für PKW, LKW, Motorräder und mehr
          </Typography>
        </Box>

        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Paper elevation={4} sx={{ p: 4, textAlign: 'center', bgcolor: siteConfig.colors.lightGray }}>
              <TrendingUp sx={{ fontSize: 60, color: siteConfig.colors.primary, mb: 2 }} />
              <Typography variant="h2" sx={{ fontWeight: 'bold', color: siteConfig.colors.primary, mb: 1 }}>
                {siteConfig.stats.diesel.value}%
              </Typography>
              <Typography variant="h6" sx={{ color: siteConfig.colors.text }}>
                Leistungssteigerung bei {siteConfig.stats.diesel.label}
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper elevation={4} sx={{ p: 4, textAlign: 'center', bgcolor: siteConfig.colors.primary, color: 'white' }}>
              <TrendingUp sx={{ fontSize: 60, color: 'white', mb: 2 }} />
              <Typography variant="h2" sx={{ fontWeight: 'bold', mb: 1 }}>
                {siteConfig.stats.petrol.value}%
              </Typography>
              <Typography variant="h6">
                Leistungssteigerung bei {siteConfig.stats.petrol.label}
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper elevation={4} sx={{ p: 4, textAlign: 'center', bgcolor: siteConfig.colors.lightGray }}>
              <TrendingUp sx={{ fontSize: 60, color: siteConfig.colors.primary, mb: 2 }} />
              <Typography variant="h2" sx={{ fontWeight: 'bold', color: siteConfig.colors.primary, mb: 1 }}>
                {siteConfig.stats.naturally.value}%
              </Typography>
              <Typography variant="h6" sx={{ color: siteConfig.colors.text }}>
                Leistungsoptimierung bei Fahrzeugen {siteConfig.stats.naturally.label}
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        <Box sx={{ mt: 6, p: 4, bgcolor: siteConfig.colors.lightGray, borderRadius: 2 }}>
          <Typography variant="body1" sx={{ textAlign: 'center', lineHeight: 1.8 }}>
            Wir optimieren nicht nur PKW, Motorräder, LKW und Busse, sondern auch Wohnmobile, 
            Traktoren, Landmaschinen und Bootsmotoren. Chiptuning steigert nicht nur Ihren 
            Fahrspaß durch bessere Beschleunigung und Durchzug, sondern lohnt sich auch der 
            Umwelt zuliebe, die durch einen geringeren Verbrauch erheblich geschont wird.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default PerformanceStats;
